import axios from "axios";
import {wrapper} from "axios-cookiejar-support";
import {CookieJar} from "tough-cookie";
import {baseurly, X_API_KEY} from "./apis.ts";

wrapper(axios);

const cookieJar = new CookieJar();
export const axiosL = axios.create({
    jar: cookieJar,
    withCredentials: true,
    baseURL: baseurly,
    headers: {
        // "X-Frame-Options": `ALLOW-FROM ${API_URL} `,
    
        'X-API-KEY': X_API_KEY,
    },
})